import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import "../../assets/css/Product_cart.css";
import { check1 } from "../../constants";
import { useState } from "react";
import { useEffect } from "react";
import $, { data } from "jquery";
const Product_cart = () => {
	const [Count, SetCount] = useState(1);

	if (Count < 0) {
		SetCount(0);
	}
	useEffect(() => {
		$(document).ready(function () {
			$(data.qty).change(function () {
				if ($(this).val() == 1) {
					$(this).text = 1;
				}
			});
		});
	}, []);
	const [cart, setCart] = useState([
		{
			id: 1,
			IMAGE: check1,
			NAME: "Sweet Black Shirt",
			UNIT_PRICE: "158.07",
			SUB_TOTAL: "158.07",
			qty: 1,
			min: 1,
		},
		{
			id: 2,
			IMAGE: check1,
			NAME: "Sweet Black Shirt",
			UNIT_PRICE: "158.07",
			SUB_TOTAL: "158.07",
			qty: 1,
			min: 1,
		},
		{
			id: 3,
			IMAGE: check1,
			NAME: "Sweet Black Shirt",
			UNIT_PRICE: "158.07",
			SUB_TOTAL: "158.07",
			qty: 1,
			min: 1,
		},
		{
			id: 4,
			IMAGE: check1,
			NAME: "Sweet Black Shirt",
			UNIT_PRICE: "158.07",
			SUB_TOTAL: "158.07",
			qty: 1,
			min: 1,
		},
		{
			id: 5,
			IMAGE: check1,
			NAME: "Sweet Black Shirt",
			UNIT_PRICE: "158.07",
			SUB_TOTAL: "158.07",
			qty: 1,
			min: 1,
		},
	]);

	const onChangeQty = (qty, id) => {
		setCart((preVal) => {
			let data = [...preVal];
			let index = data.findIndex((val) => val?.id === id);
			if (index >= 0) {
				data[index]["qty"] = qty;
			}
			if (qty < 1) {
				data[index]["qty"] = 1;
			}

			return data;
		});
	};

	return (
		<>
			{/* Header starts here */}
			<Header />
			{/* Header ends here */}
			{/* wishlist starts here */}
			<section className="wishlist-sec">
				<div className="container">
					<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-10">
							<div className="heading-wrapper">
								<h4>View Cart</h4>
							</div>
							<div className="wishlist-wrapper">
								<div className="table-responsive">
									<table className="table">
										<thead>
											<tr>
												<th className="pro-img">Image</th>
												<th className="pro-name">PRODUCT NAME</th>
												<th className="PRICE-name">UNIT PRICE</th>
												<th className="Avalablity-name">QUANTITY</th>
												<th className="Action-name">SUB TOTAL</th>
												<th className="close"></th>
											</tr>
										</thead>
										<tbody>
											{cart.map((data, index) => {
												return (
													<>
														<tr>
															<td className="product-img">
																<figure>
																	<img src={data?.IMAGE} alt="" />
																</figure>
															</td>
															<td className="product-name">
																<div className="product-wrapper">
																	<h6>{data?.NAME}</h6>
																</div>
															</td>
															<td className="price-name">
																<h6>${data?.UNIT_PRICE} </h6>
															</td>
															<td className="stock-name">
																<div className="counter-wrapper">
																	<div className="counter-field-wrapper">
																		<input type="number" value={data.qty} />
																	</div>
																	<div className="counter-btn-wrapper">
																		<button
																			onClick={() =>
																				onChangeQty(
																					parseInt(data.qty + 1),
																					data.id,
																				)
																			}
																			className="plus"
																		>
																			<i className="fa-solid fa-angle-up"></i>
																		</button>
																		<button
																			onClick={() =>
																				onChangeQty(
																					parseInt(data.qty - 1),
																					data.id,
																				)
																			}
																			className="minus"
																		>
																			<i className="fa-solid fa-angle-down"></i>
																		</button>
																	</div>
																</div>
															</td>
															<td className="product-name">
																<h6>${data.UNIT_PRICE} </h6>
															</td>
															<td className="close-col">
																<button>
																	<svg
																		xmlns="http://www.w3.org/2000/svg"
																		width="16.5"
																		height="21.214"
																		viewBox="0 0 16.5 21.214"
																	>
																		<g
																			id="cancel"
																			transform="translate(2.25 6.698)"
																		>
																			<path
																				id="Icon_material-delete-forever"
																				data-name="Icon material-delete-forever"
																				d="M8.679,23.357a2.364,2.364,0,0,0,2.357,2.357h9.429a2.364,2.364,0,0,0,2.357-2.357V9.214H8.679Zm2.9-8.391L13.24,13.3l2.51,2.5,2.5-2.5,1.662,1.662-2.5,2.5,2.5,2.5-1.662,1.662-2.5-2.5-2.5,2.5L11.59,19.963l2.5-2.5Zm8.3-9.287L18.7,4.5H12.8L11.625,5.679H7.5V8.036H24V5.679Z"
																				transform="translate(-9.75 -11.198)"
																				fill="#9a3407"
																			/>
																		</g>
																	</svg>
																</button>
															</td>
														</tr>
													</>
												);
											})}
										</tbody>
									</table>
								</div>
								<div className="discount-row-wrapper">
									<div className="row">
										<div className="col-lg-6">
											{/* <div className="copon-wrapper">
												<label htmlFor="">Discount codes</label>
												<div className="input-group">
													<input
														type="email"
														className="form-control"
														placeholder="Enter your coupon code if you have one."
													/>
													<span className="input-group-btn">
														<button className="btn" type="submit">
															APPLY
														</button>
													</span>
												</div>
											</div> */}
										</div>
										<div className="col-lg-2"></div>
										<div className="col-lg-4">
											<div className="discount-wrapper">
												<div className="discount-list-wrapper">
													<ul>
														<li>
															<span className="property">Subtotal</span>
															<span className="value">$ 700.00</span>
														</li>
														<li>
															<span className="property">
																Estimated Shipping Cost
															</span>
															<span className="value">Free Shipping</span>
														</li>
													</ul>
												</div>
												<div className="total-cost-wrapper">
													<ul>
														<li>
															<span className="property"> TOTAL COST </span>
															<span className="value">$ 700.15</span>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-lg-6">
									<div className="btn-wrapper fst-btn">
										<button className="btn">Continue Shopping</button>
										<button className="btn-Clear ">Update Cart</button>
									</div>
								</div>
								<div className="col-lg-6">
									<div className="btn-wrapper text-right">
										<a href="/checkout" className="btn">
											Proceed to Checkout
										</a>
										<p className="mt-3">
											You’ll still have a chance to review your order
										</p>
									</div>
								</div>
							</div>
						</div>
						<div className="col-lg-1"></div>
					</div>
				</div>
			</section>
			{/* wishlist ends here */}
			{/* Footer starts here */}
			<Footer />
			{/* Footer ends here */}
		</>
	);
};

export default Product_cart;
